import React from 'react';

import ContentCard from 'pages/Landings/components/ContentCard';
import EmailLink from 'pages/Landings/components/EmailLink';

import useContactSalesDialog from './hooks/use-contact-sales-dialog';

import ActionButton from '../ActionButton';

interface Props {
    className?: string;
}

const Sales: React.FC<Props> = ({ className }) => {
    const [dialog, openDialog] = useContactSalesDialog();
    return (
        <>
            <ContentCard
                title={'Talk to sales'}
                subtitle={'Drop us an email to discuss your use-case or clarify commercial questions at'}
                additional={<EmailLink email="sales@vulners.com" />}
                actions={
                    <ActionButton color="light" fullWidth onClick={openDialog}>
                        {'Contact sales'}
                    </ActionButton>
                }
                className={className}
            />
            {dialog}
        </>
    );
};

export default Sales;
